import { Component, Input, OnInit } from '@angular/core';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { BaseForm } from '@app/modules/forms/base.form';
import { TimeOffCreateFlowService } from '@app/modules/time-off-v3/services';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-carryover-balance-form',
    templateUrl: 'carryover-balance.template.html',
})
export class CarryoverBalanceForm extends BaseForm implements OnInit {
    @Input() timeOffPolicy = new TimeOffPolicy();

    private timeOffPolicySubscription!: Subscription;

    constructor(private timeOffCreateFlowService: TimeOffCreateFlowService) {
        super();
    }

    ngOnInit(): void {
        this.timeOffPolicySubscription = this.timeOffCreateFlowService.timeOffPolicy$.subscribe((policy) => {
            this.timeOffPolicy = policy;
        });
    }

    updateTimeOffPolicy(): void {
        this.timeOffCreateFlowService.updateTimeOffPolicy(this.timeOffPolicy);
    }

    ngOnDestroy(): void {
        this.timeOffPolicySubscription.unsubscribe();
    }
}
